var render, staticRenderFns
import script from "./ApiDatatableMixin.vue?vue&type=script&lang=js"
export * from "./ApiDatatableMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a57608",
  null
  
)

export default component.exports